export const SUPPLIER_PURCHASE_ORDER_COLUMN = [
  {
    Header: "SUPPLIER",
    accessor: "Supplier",
    show: true,
  },
  {
    Header: "PO. NUMBER",
    accessor: "PONumber",
    show: true,
  },
  {
    Header: "PO. DATE",
    accessor: "PODate",
    show: true,
  },
  {
    Header: "DUE DATE",
    accessor: "duedate",
    show: true,
  },
  {
    Header: "PO. TYPE",
    accessor: "POType",
    show: false,
  },
  {
    Header: "PAYMENT TERMS",
    accessor: "PaymentTerms",
    show: true,
  },
  {
    Header: "QUANTITY",
    accessor: "QTY",
    show: true,
  },
  {
    Header: "PENDING QTY.",
    accessor: "PendingQTY",
    show: true,
  },
  {
    Header: "DELIVERY TERMS",
    accessor: "DeliveryTerms",
    show: true,
  },
  {
    Header: "PO. STATUS",
    accessor: "LatestAction",
    show: true,
  },
  {
    Header: "REMARK",
    accessor: "Remarks",
    show: false,
  },
];

export const SUPPLIER_GRN_ORDER_COLUMN = [
  {
    Header: "SUPPLIER NAME",
    accessor: "SupplierName",
    show: true,
    exportable:true,
  },
  {
    Header: "PO. NUMBER",
    accessor: "PONumber",
    show: true,
    exportable:true,
  },
  {
    Header: "PART NUMBER",
    accessor: "PartNo",
    show: true,
    exportable:true,
  },
  {
    Header: "RECEIPT NUMBER",
    accessor: "ReceiptNo",
    show: true,
    exportable:true,
  },
  {
    Header: "SUPPLIER INVOICE NUMBER",
    accessor: "SupplierInvoiceNo",
    show: false,
  },
  {
    Header: "SUPPLIER INVOICE DATE",
    accessor: "SupplierInvoiceDate",
    show: false,
    exportable:true,
  },
  {
    Header: "TOTAL PACKAGE COUNT",
    accessor: "TotalPackageCount",
    show: false,
    exportable:true,
  },
  {
    Header: "TRANSPORTER",
    accessor: "Transporter",
    show: false,
    exportable:false,
  },
  {
    Header: "DRIVER NAME",
    accessor: "DriverName",
    show: false,
    exportable:false,
  },
  {
    Header: "DRIVER CONTACT NO.",
    accessor: "DriverContactNo",
    show: false,
    exportable:false,
  },
  {
    Header: "VEHICEL TYPE",
    accessor: "VehicleType",
    show: false,
    exportable:false,
  },
  {
    Header: "VEHICEL NUMBER",
    accessor: "VehicleNo",
    show: false,
    exportable:false,
  },
  {
    Header: "PICKUP POINT",
    accessor: "PickUpPoint",
    show: false,
    exportable:false,
  },
  {
    Header: "LR NO.",
    accessor: "LRNo",
    show: false,
    exportable:false,
  },
  {
    Header: "LR DATE",
    accessor: "LRDate",
    show: false,
    exportable:false,
  },
  {
    Header: "RECEIPT DATE",
    accessor: "ReceiptDate",
    show: true,
    exportable:true,
  },
  {
    Header: "MODIFIED DATE",
    accessor: "ModifiedDate",
    show: false,
    exportable:false,
  },
  {
    Header: "RECEIPT AMOUNT",
    accessor: "InvoiceAmount",
    show: false,
    exportable:false,
  },
  {
    Header: "EXCISE",
    accessor: "Excise",
    show: false,
    exportable:false,
  },
  {
    Header: "TCS",
    accessor: "TCS",
    show: false,
    exportable:false,
  },
  {
    Header: "END CESS",
    accessor: "EdCess",
    show: false,
    exportable:false,
  },
  {
    Header: "HEAD CESS",
    accessor: "HedCess",
    show: false,
    exportable:false,
  },
  {
    Header: "VAR %",
    accessor: "VatPercent",
    show: false,
    exportable:false,
  },
  {
    Header: "VAT AMOUNT",
    accessor: "VatAmount",
    show: false,
    exportable:false,
  },
  {
    Header: "FINAL INVOICE AMOUNT",
    accessor: "FinalInvoiceAmount",
    show: false,
    exportable:false,
  },
  {
    Header: "QC DATE TIME",
    accessor: "QCDateTime",
    show: false,
    exportable:true,
  },
  {
    Header: "QC REMARKS",
    accessor: "QCRemarks",
    show: true,
    exportable:true,
  },
  {
    Header: "QC PERFORMED BY",
    accessor: "QCPerformedBy",
    show: false,
    exportable:false,
  },
  {
    Header: "RECEIVED QTY.",
    accessor: "ReceivedQty",
    show: false,
    exportable:true,
  },
  {
    Header: "PART PRICE",
    accessor: "PartPrice",
    show: false,
    exportable:false,
  },
  {
    Header: "ACCEPTED QTY.",
    accessor: "AcceptedQty",
    show: true,
    exportable:true,
  },
  {
    Header: "REJECTED QTY.",
    accessor: "RejectedQty",
    show: false,
    exportable:true,
    
  },
  {
    Header: "IS ATA",
    accessor: "IsATA",
    show: false,
    exportable:false,
  },
  {
    Header: "SAC CODE",
    accessor: "SAC_Code",
    show: false,
    exportable:false,
  },
  {
    Header: "DELIVERY TERM",
    accessor: "DeliveryTerm",
    show: false,
    exportable:false,
  },
  {
    Header: "MATHADI CHARGES",
    accessor: "MathadiCharges",
    show: false,
    exportable:false,
  },
  {
    Header: "TRANSPORTATION CHARGES",
    accessor: "TransportationCharges",
    show: false,
    exportable:false,
  },
  {
    Header: "MATHADI DATE",
    accessor: "MathadiDate",
    show: false,
    exportable:false,
  },
  {
    Header: "MATHADI RECEIPT NO.",
    accessor: "MathadiReceiptNo",
    show: false,
    exportable:false,
  },
  {
    Header: "VIEW GRN",
    accessor: "view",
    show: true,
    exportable:false,
  },
];

export const SUPPLIER_FORECAST_ORDER_COLUMN = [
  {
    Header: "SUPPLIER NAME",
    accessor: "SupplierName",
    show: true,
  },
  {
    Header: "PART NUMBER",
    accessor: "PartNo",
    show: true,
  },
  {
    Header: "PART DESCRIPTION",
    accessor: "PartDescription",
    show: false,
  },
  {
    Header: "DUE DATE",
    accessor: "DueDate",
    show: true,
  },
  {
    Header: "SUPPLIER DUE DATE",
    accessor: "SupplierDueDate",
    show: false,
  },
  {
    Header: "IMPEX PO. NUMBER",
    accessor: "PONumber",
    show: true,
  },
  {
    Header: "ORDER TYPE",
    accessor: "OrderType",
    show: true,
  },
  {
    Header: "TRANSIT TIME",
    accessor: "TransitTime",
    show: false,
  },
  {
    Header: "PRICE",
    accessor: "Price",
    show: true,
  },
  {
    Header: "CURRENCY",
    accessor: "Currency",
    show: false,
  },
  {
    Header: "PO. QTY.",
    accessor: "POQTY",
    show: false,
  },
  {
    Header: "IN HAND QTY.",
    accessor: "InHandQTY",
    show: false,
  },
  {
    Header: "HSN",
    accessor: "HSN",
    show: false,
  },
];
